import {
  ReplaceWhitelistBody,
  ReplaceWhitelistParams as ReplaceWhitelistQuery,
  ReplaceWhitelistResponse,
} from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { TFAQueryFnParams } from 'modules/tfa/types';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';
import { web3Api } from 'store/queries';
import { errorHandlerWithNotification } from 'domains/userSettings/actions/utils/errorHandlerWithNotification';

import { updateProjectWhitelist } from './utils/updateProjectWhitelist';

export interface ReplaceWhitelistParams extends ReplaceWhitelistQuery {
  whitelist: ReplaceWhitelistBody;
}

export const {
  endpoints: { replaceWhitelist },
  useReplaceWhitelistMutation,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    replaceWhitelist: build.mutation<
      ReplaceWhitelistResponse,
      TFAQueryFnParams<ReplaceWhitelistParams>
    >({
      queryFn: createQueryFnWithErrorHandler({
        errorHandler: errorHandlerWithNotification,
        queryFn: async ({
          params: { group, mode, token, whitelist },
          totp,
        }) => {
          const api = MultiService.getService().getAccountingGateway();

          const data = await api.replaceWhitelist(
            { group, mode, token },
            whitelist,
            totp,
          );

          return { data };
        },
      }),
      onQueryStarted: async (
        { params: { group: teamAddress, token } },
        { dispatch, queryFulfilled },
      ) => {
        const { data: replaceWhitelistResponse } = await queryFulfilled;

        updateProjectWhitelist({
          teamAddress,
          dispatch,
          token,
          replaceWhitelistResponse,
        });
      },
    }),
  }),
});
